export * from './DocArrowOutIcon';
export * from './DocArrowOutIcon16Light';
export * from './DocArrowOutIcon16Regular';
export * from './DocArrowOutIcon16Solid';
export * from './DocArrowOutIcon20Light';
export * from './DocArrowOutIcon20Regular';
export * from './DocArrowOutIcon20Solid';
export * from './DocArrowOutIcon24Regular';
export * from './DocArrowOutIcon24Solid';
export * from './DocArrowOutIcon32Regular';
export * from './DocArrowOutIcon64Regular';
